/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const RetentionPolicyNonModifiable32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M6 0h20a6 6 0 016 6v20a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z" fill={vars.bdlLightBlue} />
            <path
                d="M21.5 15c1.607 0 2.918 1.203 2.996 2.715l.004.142v1.377c.886.406 1.5 1.3 1.5 2.337v1.858A2.571 2.571 0 0123.429 26H19.57A2.571 2.571 0 0117 23.429V21.57c0-1.037.615-1.932 1.5-2.338v-1.376c0-1.578 1.343-2.857 3-2.857zm-.653-7C21.484 8 22 8.551 22 9.23v4.802l-.248-.024L21.5 14l-.23.007-.228.02c-1.965.23-3.513 1.928-3.611 4.033l-.005.211v.258l-.079.064-.187.174a4.003 4.003 0 00-1.153 2.612l-.007.235V23.1l.006.23c.033.604.196 1.172.459 1.672L9.165 25c-.175-.007-.271-.423.026-.514.342-.13.814-.828.814-1.462V9.231c0-.68.593-1.231 1.23-1.231h9.612zM9 20v3.003A.985.985 0 018 24c-.568 0-1-.486-1-.997V20h2zm13.5 2h-2a.5.5 0 00-.09.992l.09.008h2a.5.5 0 100-1zm-1-5.571c-.79 0-1.439.582-1.496 1.322l-.004.106V19h3v-1.143c0-.789-.672-1.428-1.5-1.428z"
                fill={vars.white}
            />
        </g>
    </AccessibleSVG>
);

export default RetentionPolicyNonModifiable32;
